import * as types from "./actionTypes.js";
import * as userApi from '../../api/userApi.js';


export function fetchBranch(userId) {
  return function (dispatch) {
      return userApi
          .getBranch(userId)
          .then(branch => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_BRANCH_SUCCESS,
                  branch
              });
          })
          .catch(error => {
              throw error;
          });
  };
}
